import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {createDefaultDialogConfig} from '../../common/dialog-utils';
import {filter} from 'rxjs/operators';
import {TranslateModule} from '@ngx-translate/core';
import { ConfirmationDialogSvgSpriteComponent } from './confirmation-dialog-svg-sprite.component';
import { CloseDialogCrossIconSvgComponent } from '../../svg-sprites/general/close-dialog-cross-icon-svg.component';

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    imports: [
        TranslateModule,
        ConfirmationDialogSvgSpriteComponent,
        CloseDialogCrossIconSvgComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ConfirmationDialogComponent {
  private dialogRef = inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);

  title:string;
  confirmationText:string;
  leftButtonText:string;
  rightButtonText:string;
  isTitleTrashIconEnabled:boolean = false;
  isConfirmationTrashIconEnabled:boolean = false;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor () {
    const data = inject(MAT_DIALOG_DATA);

    this.title = data.title;
    this.confirmationText = data.confirmationText;
    this.leftButtonText = data?.leftButtonText;
    this.rightButtonText = data?.rightButtonText;
    this.isTitleTrashIconEnabled = data?.isTitleTrashIconEnabled ? data?.isTitleTrashIconEnabled : false;
    this.isConfirmationTrashIconEnabled = data?.isConfirmationTrashIconEnabled ? data?.isConfirmationTrashIconEnabled : false;
  }

  cancel() {
    this.dialogRef.close({confirm:false});
  }

  confirm() {
    this.dialogRef.close({confirm:true});
  }
}

export function openConfirmationDialog(
  dialog: MatDialog,
  title:string,
  confirmationText:string,
  leftButtonText?: string,
  rightButtonText?: string,
  isTitleTrashIconEnabled?: boolean,
  isConfirmationTrashIconEnabled?: boolean
) {

  const config = createDefaultDialogConfig();

  config.maxWidth = '490px';
  config.maxHeight = '95vh';

  config.data = {
    title,
    confirmationText,
    leftButtonText,
    rightButtonText,
    isTitleTrashIconEnabled,
    isConfirmationTrashIconEnabled
  };

  const dialogRef = dialog.open(ConfirmationDialogComponent, config);

  return dialogRef.afterClosed().pipe(
    filter(val => !!val),
  );
}
